import { useQuery } from '@tanstack/react-query';
import { LabelType } from '@interfaces/models';
import { getLabelsByType } from '@api/labels';

export const useGetLabels = (labelType: LabelType) => {
  const { data: labels = [], isFetching } = useQuery({
    queryFn: () => getLabelsByType(labelType),
    queryKey: ['labels', labelType],
  });

  const getLabelName = (labelId: string) => {
    return labels.find((label) => label.id === labelId)?.name;
  };

  const labelsOptions = labels.map((label) => ({
    label: label.name,
    value: label.id,
  }));

  return { labels, isFetching, labelsOptions, getLabelName };
};
